export default function runPageAnalytics($rootScope, $analytics, $gzAnalytics, $window) {
  'ngInject';

  $rootScope.$on('$stateChangeSuccess', () => {
    let pageName = $gzAnalytics.getPage();
    let index = pageName.indexOf('?');
    if (index !== -1) {
      pageName = pageName.substring(0, index);
    }
    // set to the current GA session as well so event hits have correct page
    $window.ga('set', 'page', pageName);
    $analytics.pageTrack(pageName);
  });
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/core/analytics/page-analytics.run.js